enum AffiliationType {
  Unknown = "Unknown",
  Group = "Group",
  Hospital = "Hospital",
  IPA = "IPA",
}

enum AffiliationAdmittingPrivilegeEnum {
  None = "none",
  Courtesy = "Courtesy",
  Full = "Full",
  Pending = "Pending",
  Provisional = "Provisional",
  Temporary = "Temporary",
}

export { AffiliationType, AffiliationAdmittingPrivilegeEnum };
